import { BASE_URL } from "@/lib/constants";
import { TGetCommunityListingResponseDTO } from "@/types/community";
import { useQuery } from "@tanstack/react-query";

const fetchCommunityListing = async (communitySlug: string) => {
	const url = new URL(`${BASE_URL}/api/v2/communities/listing`);

	url.searchParams.set("community-slug", communitySlug);

	const response = await fetch(url);
	const data = await response.json();

	return data;
};

export const useCommunitiesListingQuery = (communitySlug: string | undefined, options?: { enabled?: boolean }) => {
	return useQuery<TGetCommunityListingResponseDTO>({
		queryKey: ["community-listing", communitySlug],
		queryFn: () => {
			if (!communitySlug) {
				throw new Error("Community slug is required");
			}
			return fetchCommunityListing(communitySlug);
		},
		refetchOnWindowFocus: false,
		enabled: options?.enabled ?? true,
	});
};
